export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';

export default { DEFAULT_ASSIGN };
